import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Input,
  Dropdown,
  Checkbox,
  Button
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardEmployeeInformationUX = (props: any) => {
    return(
      <div
        style={{display: "flex", marginTop: ".5em"}}>
        <div
          id="CardEmployeeInformationUX-div-310"
          style={{ display: "flex", flexDirection: "column", alignItems: "center", marginRight: "24px", marginLeft: "12px" }}>
          
          <FormField
            id="CardEmployeeInformationUX-FormField-54"
            width={2}>
            <div
              id="CardEmployeeInformationUX-div-94"
              style={{ marginBottom: "24px" }}>
              {props.profileImage}
            </div>
          </FormField>
          <Form
            className="--override-disabled --grey"
            id="CardEmployeeInformationUX-Form-1">
            <FormGroup
              id="CardEmployeeInformationUX-FormGroup-2">
              <FormField
                className={`required ${props.showRequiredField?.code ? "error" : ""}`}
                id="CardEmployeeInformationUX-FormField-3"
                style={{position: "relative"}}>
                <label
                  id="CardEmployeeInformationUX-label-4"
                  style={{fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "Employee Code" : "รหัสพนักงาน"}
                </label>
                <Input
                  disabled={props.readOnly}
                  id="CardEmployeeInformationUX-Input-5"
                  name="basic.code"
                  onChange={props.onChangeValue}
                  value={props.basic?.code?? ""}>
                </Input>
                <div
                  id="CardEmployeeInformationUX-div-253"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.code|| ""}
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardEmployeeInformationUX-div-311"
          style={{flex: 1}}>
          
          <div
            id="CardEmployeeInformationUX-div-312">
            
            <FormGroup
              id="CardEmployeeInformationUX-FormGroup-6"
              inline={true}
              style={{marginBottom: "0.5rem", display: props.filteredSectionList?.includes("Basic Employee Information")?"":"none"}}>
              <FormField
                id="CardEmployeeInformationUX-FormField-7"
                inline={true}
                style={{padding:0}}>
                <label
                  id="CardEmployeeInformationUX-label-8"
                  style={{color: "rgba(26, 115, 232, 1)", fontSize: "0.95rem"}}>
                  {props.languageUX === "en" ? "Basic Employee Information" : "ข้อมูลพื้นฐานพนักงาน"}
                </label>
              </FormField>
            </FormGroup>
          </div>
          <div
            className="ui form --override-disabled --grey"
            id="CardEmployeeInformationUX-div-9"
            style={{backgroundColor: "rgba(240, 249, 252, 1)", padding: "1rem 10px",display: props.filteredSectionList?.includes("Basic Employee Information")?"":"none"}}>
            
            <FormGroup
              id="CardEmployeeInformationUX-FormGroup-10"
              inline={true}>
              <FormField
                className="required"
                id="CardEmployeeInformationUX-FormField-11"
                inline={true}
                width={16}>
                <label
                  id="CardEmployeeInformationUX-label-12"
                  style={{fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "Identity Document" : "เอกสารแสดงตัวตน"}
                </label>
                <Dropdown
                  disabled={props.readOnly}
                  id="CardEmployeeInformationUX-Dropdown-13"
                  name="basic.citizen_type"
                  onChange={props.onChangeValue}
                  options={props.idOptions}
                  search={true}
                  selection={true}
                  value={props.basic?.citizen_type ?? ""}>
                </Dropdown>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEmployeeInformationUX-FormGroup-14"
              inline={true}>
              <FormField
                id="CardEmployeeInformationUX-FormField-15">
                <label
                  id="CardEmployeeInformationUX-label-16">
                  {props.languageUX === "en" ? "Name (in Thai)" : "ชื่อ (ภาษาไทย)"}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEmployeeInformationUX-FormGroup-17">
              <FormField
                className={props.basic?.citizen_type==="T"?`required ${props.showRequiredField?.pre_name? "error" : ""}`:""}
                id="CardEmployeeInformationUX-FormField-18"
                style={{position: "relative"}}
                width={3}>
                <label
                  id="CardEmployeeInformationUX-label-23"
                  style={{minWidth: "max-content", fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "Pre name" : "ชื่อก่อน"}
                </label>
                <Dropdown
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Dropdown-28"
                  name="basic.pre_name"
                  onChange={props.onChangeValue}
                  options={props.prenameThOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.basic?.pre_name ?? ""}>
                </Dropdown>
                <div
                  id="CardEmployeeInformationUX-div-254"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.basic?.citizen_type==="T"?props.showRequiredField?.pre_name|| "":""}
                </div>
              </FormField>
              <FormField
                className={props.basic?.citizen_type==="T"?`required ${props.showRequiredField?.first_name? "error" : ""}`:""}
                id="CardEmployeeInformationUX-FormField-19"
                style={{position: "relative"}}
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-24"
                  style={{minWidth: "max-content", fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "First name" : "ชื่อจริง"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-29"
                  name="basic.first_name"
                  onChange={props.onChangeValue}
                  value={props.basic?.first_name ?? ""}>
                </Input>
                <div
                  id="CardEmployeeInformationUX-div-255"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.basic?.citizen_type==="T"?props.showRequiredField?.first_name|| "":""}
                </div>
              </FormField>
              <FormField
                id="CardEmployeeInformationUX-FormField-20"
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-25"
                  style={{minWidth: "max-content", fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "Middle name" : "ชื่อกลาง"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-30"
                  name="basic.middle_name"
                  onChange={props.onChangeValue}
                  value={props.basic?.middle_name ?? ""}>
                </Input>
              </FormField>
              <FormField
                className={props.basic?.citizen_type==="T"?`required ${props.showRequiredField?.last_name? "error" : ""}`:""}
                id="CardEmployeeInformationUX-FormField-21"
                style={{position: "relative"}}
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-26"
                  style={{minWidth: "max-content", fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "Last name" : "นามสกุล"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-31"
                  name="basic.last_name"
                  onChange={props.onChangeValue}
                  value={props.basic?.last_name ?? ""}>
                </Input>
                <div
                  id="CardEmployeeInformationUX-div-256"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.basic?.citizen_type==="T"?props.showRequiredField?.last_name|| "":""}
                </div>
              </FormField>
              <FormField
                id="CardEmployeeInformationUX-FormField-22"
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-27"
                  style={{minWidth: "max-content", fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "Nick name" : "ชื่อเล่น"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-32"
                  name="basic.nick_name"
                  onChange={props.onChangeValue}
                  value={props.basic?.nick_name ?? ""}>
                </Input>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEmployeeInformationUX-FormGroup-33"
              inline={true}>
              <FormField
                id="CardEmployeeInformationUX-FormField-35">
                <label
                  id="CardEmployeeInformationUX-label-36">
                  {props.languageUX === "en" ? "Name (in English)" : "ชื่อ (ภาษาอังกฤษ)"}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEmployeeInformationUX-FormGroup-34">
              <FormField
                className={`required ${props.showRequiredField?.pre_name_en? "error":""}`}
                id="CardEmployeeInformationUX-FormField-37"
                style={{position: "relative"}}
                width={3}>
                <label
                  id="CardEmployeeInformationUX-label-42"
                  style={{minWidth: "max-content", fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "Pre name" : "ชื่อก่อน"}
                </label>
                <Dropdown
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Dropdown-47"
                  name="basic.pre_name_en"
                  onChange={props.onChangeValue}
                  options={props.prenameEnOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.basic?.pre_name_en ?? ""}>
                </Dropdown>
                <div
                  id="CardEmployeeInformationUX-div-257"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.pre_name_en|| ""}
                </div>
              </FormField>
              <FormField
                className={`required ${props.showRequiredField?.first_name_en? "error":""}`}
                id="CardEmployeeInformationUX-FormField-38"
                style={{position: "relative"}}
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-43"
                  style={{minWidth: "max-content", fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "First name" : "ชื่อจริง"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-48"
                  name="basic.first_name_en"
                  onChange={props.onChangeValue}
                  value={props.basic?.first_name_en ?? ""}>
                </Input>
                <div
                  id="CardEmployeeInformationUX-div-258"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.first_name_en|| ""}
                </div>
              </FormField>
              <FormField
                id="CardEmployeeInformationUX-FormField-39"
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-44"
                  style={{minWidth: "max-content", fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "Middle name" : "ชื่อกลาง"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-49"
                  name="basic.middle_name_en"
                  onChange={props.onChangeValue}
                  value={props.basic?.middle_name_en ?? ""}>
                </Input>
              </FormField>
              <FormField
                className={`required ${props.showRequiredField?.last_name_en? "error":""}`}
                id="CardEmployeeInformationUX-FormField-40"
                style={{position: "relative"}}
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-45"
                  style={{minWidth: "max-content", fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "Last name" : "นามสกุล"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-50"
                  name="basic.last_name_en"
                  onChange={props.onChangeValue}
                  value={props.basic?.last_name_en ?? ""}>
                </Input>
                <div
                  id="CardEmployeeInformationUX-div-259"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.last_name_en|| ""}
                </div>
              </FormField>
              <FormField
                id="CardEmployeeInformationUX-FormField-41"
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-46"
                  style={{minWidth: "max-content", fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "Nick name" : "ชื่อเล่น"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-51"
                  name="basic.nick_name_en"
                  onChange={props.onChangeValue}
                  value={props.basic?.nick_name_en ?? ""}>
                </Input>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEmployeeInformationUX-FormGroup-52"
              style={{marginBottom: "0"}}
              widths={16}>
              <FormField
                id="CardEmployeeInformationUX-FormField-53"
                width={14}>
                <FormGroup
                  id="CardEmployeeInformationUX-FormGroup-71"
                  style={{width: "100%"}}>
                  <FormField
                    className={`required ${props.showRequiredField?.birth_date ? "error" : ""}`}
                    id="CardEmployeeInformationUX-FormField-72"
                    style={{position: "relative"}}
                    width={4}>
                    <label
                      id="CardEmployeeInformationUX-label-83"
                      style={{minWidth: "107px"}}>
                      {props.languageUX === "en" ? "Date of Birth" : "วันเกิด"}
                    </label>
                    <div
                      id="CardEmployeeInformationUX-div-85"
                      style={{width: "100%"}}>
                      {props.birthDate}
                    </div>
                    <div
                      id="CardEmployeeInformationUX-div-260"
                      style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                      {props.showRequiredField?.birth_date|| ""}
                    </div>
                  </FormField>
                  <FormField
                    id="CardEmployeeInformationUX-FormField-73"
                    width={4}>
                    <label
                      id="CardEmployeeInformationUX-label-82"
                      style={{minWidth: "max-content"}}>
                      {props.languageUX === "en" ? "Age" : "อายุ"}
                    </label>
                    <Input
                      disabled={true}
                      fluid={true}
                      id="CardEmployeeInformationUX-Input-84"
                      value={props.age}>
                    </Input>
                  </FormField>
                  <FormField
                    className={`required ${props.showRequiredField?.nationality? "error" : ""}`}
                    id="CardEmployeeInformationUX-FormField-74"
                    style={{position: "relative"}}
                    width={4}>
                    <label
                      id="CardEmployeeInformationUX-label-81"
                      style={{minWidth: "max-content"}}>
                      {props.languageUX === "en" ? "Nationality" : "สัญชาติ"}
                    </label>
                    <Dropdown
                      disabled={props.readOnly}
                      fluid={true}
                      id="CardEmployeeInformationUX-Dropdown-78"
                      name="basic.nationality"
                      onChange={props.onChangeValue}
                      options={props.nationalityOptions}
                      search={true}
                      selection={true}
                      style={{width: "100%"}}
                      value={props.basic?.nationality ?? ""}>
                    </Dropdown>
                    <div
                      id="CardEmployeeInformationUX-div-261"
                      style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                      {props.showRequiredField?.nationality|| ""}
                    </div>
                  </FormField>
                  <FormField
                    className={`required ${props.showRequiredField?.religion? "error" : ""}`}
                    id="CardEmployeeInformationUX-FormField-75"
                    style={{position: "relative"}}
                    width={4}>
                    <label
                      id="CardEmployeeInformationUX-label-80"
                      style={{minWidth: "max-content"}}>
                      {props.languageUX === "en" ? "Religion" : "ศาสนา"}
                    </label>
                    <Dropdown
                      disabled={props.readOnly}
                      fluid={true}
                      id="CardEmployeeInformationUX-Dropdown-79"
                      name="basic.religion"
                      onChange={props.onChangeValue}
                      options={props.religionOptions}
                      search={true}
                      selection={true}
                      style={{width: "100%"}}
                      value={props.basic?.religion ?? ""}>
                    </Dropdown>
                    <div
                      id="CardEmployeeInformationUX-div-262"
                      style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                      {props.showRequiredField?.religion|| ""}
                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardEmployeeInformationUX-FormGroup-87"
                  style={{width: "100%"}}>
                  <FormField
                    className={props.basic?.citizen_type==="T"?`required ${props.showRequiredField?.citizen_no ? "error" : ""}`:""}
                    id="CardEmployeeInformationUX-FormField-88"
                    style={{position: "relative"}}
                    width={4}>
                    <label
                      id="CardEmployeeInformationUX-label-90"
                      style={{minWidth: "107px"}}>
                      {props.languageUX === "en" ? "ID card Number" : "หมายเลขบัตรประชาชน"}
                    </label>
                    <div
                      id="CardEmployeeInformationUX-div-282"
                      style={{width: "100%"}}>
                      {props.basicMaskInput}
                    </div>
                    <div
                      id="CardEmployeeInformationUX-div-263"
                      style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                      {props.basic?.citizen_type==="T"?props.showRequiredField?.citizen_no || "":""}
                    </div>
                  </FormField>
                  <FormField
                    className={props.basic?.citizen_type==="F"?`required ${props.showRequiredField?.passport_no? "error" : ""}`:""}
                    id="CardEmployeeInformationUX-FormField-89"
                    style={{position: "relative"}}
                    width={5}>
                    <label
                      id="CardEmployeeInformationUX-label-91"
                      style={{minWidth: "max-content"}}>
                      {props.languageUX === "en" ? "Passport Number" : "หมายเลขหนังสือเดินทาง"}
                    </label>
                    <Input
                      disabled={props.readOnly}
                      id="CardEmployeeInformationUX-Input-93"
                      name="basic.passport_no"
                      onChange={props.onChangeValue}
                      value={props.basic?.passport_no ?? ""}>
                    </Input>
                    <div
                      id="CardEmployeeInformationUX-div-264"
                      style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                      {props.basic?.citizen_type==="F"?props.showRequiredField?.passport_no|| "":""}
                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardEmployeeInformationUX-FormGroup-95"
                  style={{width: "100%"}}>
                  <FormField
                    className={`required ${props.showRequiredField?.phone_no? "error":""}`}
                    id="CardEmployeeInformationUX-FormField-96"
                    style={{position: "relative"}}
                    width={4}>
                    <label
                      id="CardEmployeeInformationUX-label-99"
                      style={{minWidth: "107px"}}>
                      {props.languageUX === "en" ? "Mobile Number" : "หมายเลขโทรศัพท์มือถือ"}
                    </label>
                    <Input
                      disabled={props.readOnly}
                      fluid={true}
                      id="CardEmployeeInformationUX-Input-102"
                      name="basic.phone_no"
                      onChange={props.onChangeValue}
                      value={props.basic?.phone_no?? ""}>
                    </Input>
                    <div
                      id="CardEmployeeInformationUX-div-265"
                      style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                      {props.showRequiredField?.phone_no|| ""}
                    </div>
                  </FormField>
                  <FormField
                    className={`required ${props.showRequiredField?.email? "error":""}`}
                    id="CardEmployeeInformationUX-FormField-97"
                    style={{position: "relative"}}
                    width={4}>
                    <label
                      id="CardEmployeeInformationUX-label-100"
                      style={{minWidth: "max-content"}}>
                      {props.languageUX === "en" ? "E-mail" : "อีเมล"}
                    </label>
                    <Input
                      disabled={props.readOnly}
                      fluid={true}
                      id="CardEmployeeInformationUX-Input-103"
                      name="basic.email"
                      onChange={props.onChangeValue}
                      value={props.basic?.email ?? ""}>
                    </Input>
                    <div
                      id="CardEmployeeInformationUX-div-266"
                      style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                      {props.showRequiredField?.email|| ""}
                    </div>
                  </FormField>
                  <FormField
                    id="CardEmployeeInformationUX-FormField-98"
                    width={4}>
                    <label
                      id="CardEmployeeInformationUX-label-101"
                      style={{minWidth: "max-content"}}>
                      {props.languageUX === "en" ? "Line ID" : "ไลน์ไอดี"}
                    </label>
                    <Input
                      disabled={props.readOnly}
                      fluid={true}
                      id="CardEmployeeInformationUX-Input-104"
                      name="basic.line_id"
                      onChange={props.onChangeValue}
                      value={props.basic?.line_id ?? ""}>
                    </Input>
                  </FormField>
                </FormGroup>
              </FormField>
            </FormGroup>
          </div>
          <div
            id="CardEmployeeInformationUX-div-105"
            style={{color: "rgba(26, 115, 232, 1)", fontSize: "0.95rem", margin: "1rem 0 0.5rem", fontWeight: "bold",display: props.filteredSectionList?.includes("Personal Information")?"":"none"}}>
            {props.languageUX === "en" ? "Personal Information" : "ข้อมูลส่วนบุคคล"}
          </div>
          <div
            className="ui form --override-disabled --grey"
            id="CardEmployeeInformationUX-div-106"
            style={{backgroundColor: "rgba(240, 249, 252, 1)", padding: "1rem 10px",display: props.filteredSectionList?.includes("Personal Information")?"":"none"}}>
            
            <FormGroup
              id="CardEmployeeInformationUX-FormGroup-107"
              style={{marginBottom: 0}}
              widths={16}>
              <FormField
                id="CardEmployeeInformationUX-FormField-108"
                width={14}>
                <FormGroup
                  id="CardEmployeeInformationUX-FormGroup-110"
                  style={{width: "100%"}}>
                  <FormField
                    className={`required ${props.showRequiredField?.marital_status? "error" : ""}`}
                    id="CardEmployeeInformationUX-FormField-111"
                    style={{position: "relative"}}
                    width={4}>
                    <label
                      id="CardEmployeeInformationUX-label-113"
                      style={{minWidth: "105px"}}>
                      {props.languageUX === "en" ? "Marital Status" : "สถานภาพสมรส"}
                    </label>
                    <Dropdown
                      disabled={props.readOnly}
                      fluid={true}
                      id="CardEmployeeInformationUX-Dropdown-115"
                      name="personal.marital_status"
                      onChange={props.onChangeValue}
                      options={props.maritalStatusOptions}
                      search={true}
                      selection={true}
                      style={{width: "100%"}}
                      value={props.personal?.marital_status ?? ""}>
                    </Dropdown>
                    <div
                      id="CardEmployeeInformationUX-div-271"
                      style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                      {props.showRequiredField?.marital_status|| ""}
                    </div>
                  </FormField>
                  <FormField
                    id="CardEmployeeInformationUX-FormField-112"
                    width={8}>
                    <label
                      id="CardEmployeeInformationUX-label-114"
                      style={{minWidth: "max-content"}}>
                      {props.languageUX === "en" ? "Spouse’s Name" : "ชื่อคู่สมรส"}
                    </label>
                    <Input
                      disabled={props.isSingle || props.readOnly}
                      fluid={true}
                      id="CardEmployeeInformationUX-Input-116"
                      name="name"
                      onChange={props.onChangeSpouseName}
                      value={props.spouseName ?? ""}>
                    </Input>
                  </FormField>
                </FormGroup>
                <div
                  id="CardEmployeeInformationUX-div-117">
                  {props.childrenList}
                </div>
              </FormField>
              <FormField
                id="CardEmployeeInformationUX-FormField-109">
              </FormField>
            </FormGroup>
          </div>
          <div
            id="CardEmployeeInformationUX-div-118"
            style={{color: "rgba(26, 115, 232, 1)", fontSize: "0.95rem", margin: "1rem 0 0.5rem", fontWeight: "bold",display: props.filteredSectionList?.includes("Address on ID Card")?"":"none"}}>
            {props.languageUX === "en" ? "Address on ID Card" : "ที่อยู่บนบัตรประจำตัวประชาชน"}
          </div>
          <div
            className="ui form --override-disabled --grey"
            id="CardEmployeeInformationUX-div-119"
            style={{backgroundColor: "rgba(240, 249, 252, 1)", padding: "1rem 10px",display: props.filteredSectionList?.includes("Address on ID Card")?"":"none"}}>
            
            <FormGroup
              id="CardEmployeeInformationUX-FormGroup-120">
              <FormField
                className={`required ${props.showRequiredField?.id_card_address?.no? "error" : ""}`}
                id="CardEmployeeInformationUX-FormField-122"
                style={{position: "relative"}}
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-131"
                  style={{minWidth: "105px"}}>
                  {props.languageUX === "en" ? "House number" : "บ้านเลขที่"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-140"
                  name="id_card_address.no"
                  onChange={props.onChangeValue}
                  value={props.idCardAddress?.no?? ""}>
                </Input>
                <div
                  id="CardEmployeeInformationUX-div-284"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.id_card_address?.no|| ""}
                </div>
              </FormField>
              <FormField
                id="CardEmployeeInformationUX-FormField-123"
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-132"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Village name" : "ชื่อหมู่บ้าน"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-141"
                  name="id_card_address.name"
                  onChange={props.onChangeValue}
                  value={props.idCardAddress?.name?? ""}>
                </Input>
              </FormField>
              <FormField
                id="CardEmployeeInformationUX-FormField-124"
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-133"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Alley/Soi" : "ซอย"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-142"
                  name="id_card_address.street"
                  onChange={props.onChangeValue}
                  value={props.idCardAddress?.street?? ""}>
                </Input>
              </FormField>
              <FormField
                id="CardEmployeeInformationUX-FormField-125"
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-134"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Intersection" : "จุดตัด"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-143"
                  name="id_card_address.substreet"
                  onChange={props.onChangeValue}
                  value={props.idCardAddress?.substreet?? ""}>
                </Input>
              </FormField>
              <FormField
                className={`required ${props.showRequiredField?.id_card_address?.road? "error" : ""}`}
                id="CardEmployeeInformationUX-FormField-126"
                style={{position: "relative"}}
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-135"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Street" : "ถนน"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-144"
                  name="id_card_address.road"
                  onChange={props.onChangeValue}
                  value={props.idCardAddress?.road?? ""}>
                </Input>
                <div
                  id="CardEmployeeInformationUX-div-285"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.id_card_address?.road|| ""}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEmployeeInformationUX-FormGroup-121"
              style={{marginBottom: 0}}>
              <FormField
                className={`required ${props.showRequiredField?.id_card_address?.province? "error" : ""}`}
                id="CardEmployeeInformationUX-FormField-129"
                style={{position: "relative"}}
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-138"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Province" : "จังหวัด"}
                </label>
                <Dropdown
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Dropdown-148"
                  name="id_card_address.province"
                  onChange={props.onChangeValue}
                  options={props.provinceOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.idCardAddress?.province?? ""}>
                </Dropdown>
                <div
                  id="CardEmployeeInformationUX-div-287"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.id_card_address?.province|| ""}
                </div>
              </FormField>
              <FormField
                className={`required ${props.showRequiredField?.id_card_address?.district? "error" : ""}`}
                id="CardEmployeeInformationUX-FormField-128"
                style={{position: "relative"}}
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-137"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "District/Area" : "เขต/พื้นที่"}
                </label>
                <Dropdown
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Dropdown-147"
                  name="id_card_address.district"
                  onChange={props.onChangeValue}
                  options={props.idCardDistrictOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.idCardAddress?.district?? ""}>
                </Dropdown>
                <div
                  id="CardEmployeeInformationUX-div-288"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.id_card_address?.district|| ""}
                </div>
              </FormField>
              <FormField
                className={`required ${props.showRequiredField?.id_card_address?.city? "error" : ""}`}
                id="CardEmployeeInformationUX-FormField-127"
                style={{position: "relative"}}
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-136"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Sub-district/Sub-area" : "ตำบล/เขต"}
                </label>
                <Dropdown
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Dropdown-146"
                  name="id_card_address.city"
                  onChange={props.onChangeValue}
                  options={props.idCardCityOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.idCardAddress?.city?? ""}>
                </Dropdown>
                <div
                  id="CardEmployeeInformationUX-div-289"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.id_card_address?.city|| ""}
                </div>
              </FormField>
              <FormField
                className={`required ${props.showRequiredField?.id_card_address?.zipcode? "error" : ""}`}
                id="CardEmployeeInformationUX-FormField-130"
                style={{position: "relative"}}
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-139"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Postal Code" : "รหัสไปรษณีย์"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-145"
                  name="id_card_address.zipcode"
                  onChange={props.onChangeValue}
                  value={props.idCardAddress?.zipcode?? ""}>
                </Input>
                <div
                  id="CardEmployeeInformationUX-div-286"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.id_card_address?.zipcode|| ""}
                </div>
              </FormField>
            </FormGroup>
          </div>
          <div
            id="CardEmployeeInformationUX-div-149"
            style={{color: "rgba(26, 115, 232, 1)", fontSize: "0.95rem", margin: "1rem 0 0.5rem", fontWeight: "bold",display: props.filteredSectionList?.includes("Contact Information")?"":"none"}}>
            {props.languageUX === "en" ? "Contact Information" : "ข้อมูลการติดต่อ"}
          </div>
          <div
            className="ui form --override-disabled --grey"
            id="CardEmployeeInformationUX-div-150"
            style={{backgroundColor: "rgba(240, 249, 252, 1)", padding: "1rem 10px",display: props.filteredSectionList?.includes("Contact Information")?"":"none"}}>
            
            <FormGroup
              id="CardEmployeeInformationUX-FormGroup-151"
              style={{marginBottom: "0.25rem"}}>
              <FormField
                id="CardEmployeeInformationUX-FormField-155">
                <label
                  id="CardEmployeeInformationUX-label-167">
                  {props.languageUX === "en" ? "Current Address" : "ที่อยู่ปัจจุบัน"}
                </label>
              </FormField>
              <FormField
                id="CardEmployeeInformationUX-FormField-179">
                <div
                  id="CardEmployeeInformationUX-div-181">
                  {props.currentAddress}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEmployeeInformationUX-FormGroup-152">
              <FormField
                className={`required ${props.showRequiredField?.contact_address?.no? "error" : ""}`}
                id="CardEmployeeInformationUX-FormField-156"
                style={{position: "relative"}}
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-168"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "House number" : "บ้านเลขที่"}
                </label>
                <Input
                  disabled={!!props.contactAddress?.use_id_card_address_as_contact || props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-182"
                  name="contact_address.no"
                  onChange={props.onChangeValue}
                  value={props.contactAddress?.no?? ""}>
                </Input>
                <div
                  id="CardEmployeeInformationUX-div-297"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.contact_address?.no|| ""}
                </div>
              </FormField>
              <FormField
                id="CardEmployeeInformationUX-FormField-157"
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-169"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Village name" : "ชื่อหมู่บ้าน"}
                </label>
                <Input
                  disabled={!!props.contactAddress?.use_id_card_address_as_contact|| props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-183"
                  name="contact_address.name"
                  onChange={props.onChangeValue}
                  value={props.contactAddress?.name?? ""}>
                </Input>
              </FormField>
              <FormField
                id="CardEmployeeInformationUX-FormField-158"
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-170"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Alley/Soi" : "ซอย"}
                </label>
                <Input
                  disabled={!!props.contactAddress?.use_id_card_address_as_contact|| props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-184"
                  name="contact_address.street"
                  onChange={props.onChangeValue}
                  value={props.contactAddress?.street?? ""}>
                </Input>
              </FormField>
              <FormField
                id="CardEmployeeInformationUX-FormField-159"
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-171"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Intersection" : "จุดตัด"}
                </label>
                <Input
                  disabled={!!props.contactAddress?.use_id_card_address_as_contact|| props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-185"
                  name="contact_address.substreet"
                  onChange={props.onChangeValue}
                  value={props.contactAddress?.substreet?? ""}>
                </Input>
              </FormField>
              <FormField
                className={`required ${props.showRequiredField?.contact_address?.road? "error" : ""}`}
                id="CardEmployeeInformationUX-FormField-160"
                style={{position: "relative"}}
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-172"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Street" : "ถนน"}
                </label>
                <Input
                  disabled={!!props.contactAddress?.use_id_card_address_as_contact|| props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-186"
                  name="contact_address.road"
                  onChange={props.onChangeValue}
                  value={props.contactAddress?.road?? ""}>
                </Input>
                <div
                  id="CardEmployeeInformationUX-div-296"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.contact_address?.road|| ""}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEmployeeInformationUX-FormGroup-153">
              <FormField
                className={`required ${props.showRequiredField?.contact_address?.province? "error" : ""}`}
                id="CardEmployeeInformationUX-FormField-163"
                style={{position: "relative"}}
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-175"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Province" : "จังหวัด"}
                </label>
                <Dropdown
                  disabled={!!props.contactAddress?.use_id_card_address_as_contact||props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Dropdown-188"
                  name="contact_address.province"
                  onChange={props.onChangeValue}
                  options={props.provinceOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.contactAddress?.province?? ""}>
                </Dropdown>
                <div
                  id="CardEmployeeInformationUX-div-293"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.contact_address?.province|| ""}
                </div>
              </FormField>
              <FormField
                className={`required ${props.showRequiredField?.contact_address?.district? "error" : ""}`}
                id="CardEmployeeInformationUX-FormField-162"
                style={{position: "relative"}}
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-174"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "District/Area" : "เขต/พื้นที่"}
                </label>
                <Dropdown
                  disabled={!!props.contactAddress?.use_id_card_address_as_contact||props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Dropdown-189"
                  name="contact_address.district"
                  onChange={props.onChangeValue}
                  options={props.contactDistrictOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.contactAddress?.district?? ""}>
                </Dropdown>
                <div
                  id="CardEmployeeInformationUX-div-294"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.contact_address?.district|| ""}
                </div>
              </FormField>
              <FormField
                className={`required ${props.showRequiredField?.contact_address?.city? "error" : ""}`}
                id="CardEmployeeInformationUX-FormField-161"
                style={{position: "relative"}}
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-173"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Sub-district/Sub-area" : "ตำบล/เขต"}
                </label>
                <Dropdown
                  disabled={!!props.contactAddress?.use_id_card_address_as_contact||props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Dropdown-190"
                  name="contact_address.city"
                  onChange={props.onChangeValue}
                  options={props.contactCityOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.contactAddress?.city?? ""}>
                </Dropdown>
                <div
                  id="CardEmployeeInformationUX-div-295"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.contact_address?.city|| ""}
                </div>
              </FormField>
              <FormField
                className={`required ${props.showRequiredField?.contact_address?.zipcode? "error" : ""}`}
                id="CardEmployeeInformationUX-FormField-164"
                style={{position: "relative"}}
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-176"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Postal Code" : "รหัสไปรษณีย์"}
                </label>
                <Input
                  disabled={!!props.contactAddress?.use_id_card_address_as_contact||props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-187"
                  name="contact_address.zipcode"
                  onChange={props.onChangeValue}
                  value={props.contactAddress?.zipcode?? ""}>
                </Input>
                <div
                  id="CardEmployeeInformationUX-div-292"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.contact_address?.zipcode|| ""}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEmployeeInformationUX-FormGroup-154"
              style={{marginBottom: 0}}>
              <FormField
                className={`required ${props.showRequiredField?.contact_address?.emergency_contact_name? "error" : ""}`}
                id="CardEmployeeInformationUX-FormField-165"
                style={{position: "relative"}}
                width={6}>
                <label
                  id="CardEmployeeInformationUX-label-177"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Emergency Contact Name" : "ชื่อผู้ติดต่อฉุกเฉิน"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-192"
                  name="contact_address.emergency_contact_name"
                  onChange={props.onChangeValue}
                  value={props.contactAddress?.emergency_contact_name?? ""}>
                </Input>
                <div
                  id="CardEmployeeInformationUX-div-291"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.contact_address?.emergency_contact_name|| ""}
                </div>
              </FormField>
              <FormField
                className={`required ${props.showRequiredField?.contact_address?.emergency_contact_tel? "error" : ""}`}
                id="CardEmployeeInformationUX-FormField-166"
                style={{position: "relative"}}
                width={6}>
                <label
                  id="CardEmployeeInformationUX-label-178"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Emergency Contact Number" : "เบอร์ติดต่อฉุกเฉิน"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-191"
                  name="contact_address.emergency_contact_tel"
                  onChange={props.onChangeValue}
                  value={props.contactAddress?.emergency_contact_tel?? ""}>
                </Input>
                <div
                  id="CardEmployeeInformationUX-div-290"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.contact_address?.emergency_contact_tel|| ""}
                </div>
              </FormField>
            </FormGroup>
          </div>
          <div
            id="CardEmployeeInformationUX-div-193"
            style={{color: "rgba(26, 115, 232, 1)", fontSize: "0.95rem", margin: "1rem 0 0.5rem", fontWeight: "bold",display: props.filteredSectionList?.includes("Employment Information")?"":"none"}}>
            {props.languageUX === "en" ? "Employment Information" : "ข้อมูลการจ้างงาน"}
          </div>
          <div
            className="ui form --override-disabled --grey"
            id="CardEmployeeInformationUX-div-194"
            style={{backgroundColor: "rgba(240, 249, 252, 1)", padding: "1rem 10px",display: props.filteredSectionList?.includes("Employment Information")?"":"none"}}>
            
            <FormGroup
              id="CardEmployeeInformationUX-FormGroup-195">
              <FormField
                className={`required ${props.showRequiredField?.affiliate ? "error" : ""}`}
                id="CardEmployeeInformationUX-FormField-196"
                style={{position: "relative"}}
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-198"
                  style={{minWidth: "75px", maxWidth: "75px"}}>
                  {props.languageUX === "en" ? "Affiliation" : "สังกัด"}
                </label>
                <div
                  id="CardEmployeeInformationUX-div-252"
                  style={{width: "100%"}}>
                  {props.affiliationSearchBox}
                </div>
                <div
                  id="CardEmployeeInformationUX-div-283"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.affiliate|| ""}
                </div>
              </FormField>
              <FormGroup
                id="CardEmployeeInformationUX-FormGroup-313"
                inline={true}
                style={{marginBottom: "0", alignSelf: "flex-end"}}
                widths={7}>
                <FormField
                  id="CardEmployeeInformationUX-FormField-197"
                  style={{display: "flex", alignItems: "center"}}>
                  <Checkbox
                    checked={props.employment?.isManager ?? false}
                    disabled={props.readOnly}
                    id="CardEmployeeInformationUX-Checkbox-200"
                    label={props.languageUX === "en" ? "Is Manager" : "เป็นผู้จัดการ"}
                    name="employment.isManager"
                    onChange={props.onChangeValue}
                    style={{minWidth: "max-content", fontWeight: "bold"}}>
                  </Checkbox>
                  <Dropdown
                    disabled={!props.employment?.isManager||props.readOnly}
                    id="CardEmployeeInformationUX-Dropdown-201"
                    name="employment.managed_division"
                    onChange={props.onChangeValue}
                    options={props.managementOptions}
                    search={true}
                    selection={true}
                    style={{width: "100%"}}
                    value={props.employment?.managed_division??""}>
                  </Dropdown>
                </FormField>
              </FormGroup>
              <FormField
                className={`required ${props.showRequiredField?.employment_type ? "error" : ""}`}
                id="CardEmployeeInformationUX-FormField-202"
                style={{position: "relative"}}
                width={5}>
                <label
                  id="CardEmployeeInformationUX-label-203"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Employment type" : "ประเภทการจ้างงาน"}
                </label>
                <Dropdown
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Dropdown-204"
                  name="employment.employment_type"
                  onChange={props.onChangeValue}
                  options={props.employmentTypeOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.employment?.employment_type ?? ""}>
                </Dropdown>
                <div
                  id="CardEmployeeInformationUX-div-270"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.employment_type|| ""}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEmployeeInformationUX-FormGroup-205"
              widths={16}>
              <FormField
                className={`required ${props.showRequiredField?.position? "error" : ""}`}
                id="CardEmployeeInformationUX-FormField-206"
                style={{position: "relative"}}
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-210"
                  style={{minWidth: "75px", maxWidth: "75px", marginTop: "0.65rem"}}>
                  {props.languageUX === "en" ? "Position" : "ตำแหน่ง"}
                </label>
                <Dropdown
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Dropdown-211"
                  name="employment.position"
                  onChange={props.onChangeValue}
                  options={props.positionOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.employment?.position?? ""}>
                </Dropdown>
                <div
                  id="CardEmployeeInformationUX-div-267"
                  style={{position: "absolute", top: "34px", color: "red", fontSize: "0.75rem", right: "7px"}}>
                  {props.showRequiredField?.position|| ""}
                </div>
              </FormField>
              <FormField
                id="CardEmployeeInformationUX-FormField-207"
                style={{marginTop: "2.4em"}}
                width={13}>
                <FormGroup
                  id="CardEmployeeInformationUX-FormGroup-208"
                  inline={true}
                  style={{width: "100%"}}>
                  <FormField
                    id="CardEmployeeInformationUX-FormField-212"
                    inline={true}
                    style={{paddingRight: "0"}}>
                    <Checkbox
                      checked={props.employment?.isNoneDoctor?? false}
                      disabled={props.employment?.doctor_id||props.readOnly}
                      id="CardEmployeeInformationUX-Checkbox-214"
                      label={"\u00A0"}
                      name="employment.isNoneDoctor"
                      onChange={props.onChangeValue}>
                    </Checkbox>
                  </FormField>
                  <FormField
                    className={`${props.employment?.isNoneDoctor?"required":""} ${props.showRequiredField?.licence? "error" : ""}`}
                    id="CardEmployeeInformationUX-FormField-213"
                    inline={true}
                    style={{position: "relative"}}
                    width={8}>
                    <label
                      id="CardEmployeeInformationUX-label-215"
                      style={{minWidth: "max-content"}}>
                      {props.languageUX === "en" ? "Professional License" : "ใบอนุญาตประกอบวิชาชีพ"}
                    </label>
                    <Input
                      disabled={!props.employment?.isNoneDoctor||props.readOnly}
                      id="CardEmployeeInformationUX-Input-216"
                      name="employment.licence"
                      onChange={props.onChangeValue}
                      value={props.employment?.licence ?? ""}>
                    </Input>
                    <div
                      id="CardEmployeeInformationUX-div-301"
                      style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                      {props.showRequiredField?.licence|| ""}
                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardEmployeeInformationUX-FormGroup-209"
                  style={{width: "100%", marginBottom: 0}}>
                  <FormField
                    id="CardEmployeeInformationUX-FormField-217"
                    inline={true}
                    style={{marginTop: "2.4em"}}>
                    <Checkbox
                      checked={props.employment?.isDoctor?? false}
                      disabled={props.readOnly}
                      id="CardEmployeeInformationUX-Checkbox-221"
                      label={props.languageUX === "en" ? "Is Doctor" : "เป็นหมอ"}
                      name="employment.isDoctor"
                      onChange={props.onChangeValue}>
                    </Checkbox>
                  </FormField>
                  <FormField
                    className={`required ${props.showRequiredField?.certificate_no? "error" : ""}`}
                    id="CardEmployeeInformationUX-FormField-218"
                    style={{position: "relative"}}
                    width={4}>
                    <label
                      id="CardEmployeeInformationUX-label-224"
                      style={{minWidth: "max-content"}}>
                      {props.languageUX === "en" ? "Medical license" : "ใบอนุญาตประกอบวิชาชีพแพทย์"}
                    </label>
                    <Input
                      disabled={props.employment?.isNoneDoctor || !props.employment?.isDoctor ||props.readOnly}
                      fluid={true}
                      id="CardEmployeeInformationUX-Input-225"
                      name="employment.certificate_no"
                      onChange={props.onChangeValue}
                      value={props.employment?.certificate_no ?? ""}>
                    </Input>
                    <div
                      id="CardEmployeeInformationUX-div-272"
                      style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                      {props.showRequiredField?.certificate_no|| ""}
                    </div>
                  </FormField>
                  <FormField
                    className={`required ${props.showRequiredField?.doctor_code ? "error" : ""}`}
                    id="CardEmployeeInformationUX-FormField-219"
                    style={{position: "relative"}}
                    width={4}>
                    <label
                      id="CardEmployeeInformationUX-label-223"
                      style={{minWidth: "max-content"}}>
                      {props.languageUX === "en" ? "Doctor code" : "รหัสแพทย์"}
                    </label>
                    <Input
                      disabled={props.employment?.isNoneDoctor || !props.employment?.isDoctor || props.readOnly}
                      fluid={true}
                      id="CardEmployeeInformationUX-Input-226"
                      name="employment.doctor_code"
                      onChange={props.onChangeValue}
                      value={props.employment?.doctor_code?? ""}>
                    </Input>
                    <div
                      id="CardEmployeeInformationUX-div-273"
                      style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                      {props.showRequiredField?.doctor_code|| ""}
                    </div>
                  </FormField>
                  <FormField
                    className={`required ${props.showRequiredField?.specialties? "error" : ""}`}
                    id="CardEmployeeInformationUX-FormField-220"
                    style={{position: "relative"}}
                    width={4}>
                    <label
                      id="CardEmployeeInformationUX-label-222"
                      style={{minWidth: "max-content"}}>
                      {props.languageUX === "en" ? "Specialty" : "ความเชี่ยวชาญ"}
                    </label>
                    <Dropdown
                      disabled={props.employment?.isNoneDoctor || !props.employment?.isDoctor || props.readOnly}
                      fluid={true}
                      id="CardEmployeeInformationUX-Dropdown-227"
                      multiple={true}
                      name="employment.specialties"
                      onChange={props.onChangeValue}
                      options={props.specialtyOptions}
                      selection={true}
                      style={{width: "100%"}}
                      value={props.employment?.specialties?? ""}>
                    </Dropdown>
                    <div
                      id="CardEmployeeInformationUX-div-274"
                      style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                      {props.showRequiredField?.specialties|| ""}
                    </div>
                  </FormField>
                </FormGroup>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEmployeeInformationUX-FormGroup-228">
              <FormField
                className={`required ${props.showRequiredField?.flag_start_date? "error" : ""}`}
                id="CardEmployeeInformationUX-FormField-229"
                style={{position: "relative"}}
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-232"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Employment start date" : "วันที่เริ่มงาน"}
                </label>
                <div
                  id="CardEmployeeInformationUX-div-235"
                  style={{width: "100%"}}>
                  
                  <DateTextBox
                    disabled={props.readOnly}
                    id="CardEmployeeInformationUX-DateTextBox-238"
                    onChange={(value: any)=>props.onChangeValue?.(null,{name:"employment.flag_start_date", value})}
                    style={{color: "rgba(0,0,0,.87)"}}
                    value={props.employment?.flag_start_date?? ""}>
                  </DateTextBox>
                </div>
                <div
                  id="CardEmployeeInformationUX-div-268"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.flag_start_date|| ""}
                </div>
              </FormField>
              <FormField
                className={`required ${props.showRequiredField?.flag_end_date? "error" : ""}`}
                id="CardEmployeeInformationUX-FormField-230"
                style={{position: "relative"}}
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-233"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Employment end date" : "วันสิ้นสุดการจ้างงาน"}
                </label>
                <div
                  id="CardEmployeeInformationUX-div-236"
                  style={{width: "100%"}}>
                  {props.flagEndDate}
                </div>
                <div
                  id="CardEmployeeInformationUX-div-269"
                  style={{position: "absolute", bottom: "-16px", color: "red", fontSize: "0.75rem", right: "15px"}}>
                  {props.showRequiredField?.flag_end_date|| ""}
                </div>
              </FormField>
              <FormField
                id="CardEmployeeInformationUX-FormField-231"
                width={6}>
                <label
                  id="CardEmployeeInformationUX-label-234"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Reason" : "เหตุผล"}
                </label>
                <Input
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Input-237"
                  name="employment.inactive_reason"
                  onChange={props.onChangeValue}
                  value={props.employment?.inactive_reason ?? ""}>
                </Input>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEmployeeInformationUX-FormGroup-240"
              style={{marginBottom: 0}}>
              <FormField
                id="CardEmployeeInformationUX-FormField-241"
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-242"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Current employee status" : "สถานะพนักงานปัจจุบัน"}
                </label>
                <Dropdown
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Dropdown-243"
                  name="employment.current_status"
                  onChange={props.onChangeValue}
                  options={props.currentEmpStatusOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.employment?.current_status || ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardEmployeeInformationUX-FormField-298"
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-299">
                  {props.languageUX === "en" ? "Status" : "สถานะ"}
                </label>
                <Dropdown
                  disabled={props.readOnly}
                  fluid={true}
                  id="CardEmployeeInformationUX-Dropdown-300"
                  name="employment.status"
                  onChange={props.onChangeValue}
                  options={props.statusOptions}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.employment?.status?? ""}>
                </Dropdown>
              </FormField>
            </FormGroup>
          </div>
          <div
            id="CardEmployeeInformationUX-div-306">
            {props.educationInfo}
          </div>
          <div
            id="CardEmployeeInformationUX-div-309">
            {props.experienceInfo}
          </div>
          <div
            id="CardEmployeeInformationUX-div-244"
            style={{color: "rgba(26, 115, 232, 1)", fontSize: "0.95rem", margin: "1rem 0 0.5rem", fontWeight: "bold", display: props.readOnly?"none":props.filteredSectionList?.includes("Create a user for system access")?"":"none"}}>
            {props.languageUX === "en" ? "Create a user for system access" : "สร้างผู้ใช้สำหรับการเข้าถึงระบบ"}
          </div>
          <div
            className="ui form --override-disabled --grey"
            id="CardEmployeeInformationUX-div-245"
            style={{backgroundColor: "rgba(240, 249, 252, 1)", padding: "1rem 10px", display: props.readOnly?"none":props.filteredSectionList?.includes("Create a user for system access")?"":"none"}}>
            
            <FormGroup
              id="CardEmployeeInformationUX-FormGroup-246"
              style={{marginBottom: 0}}>
              <FormField
                id="CardEmployeeInformationUX-FormField-247"
                width={4}>
                <label
                  id="CardEmployeeInformationUX-label-248">
                  {props.languageUX === "en" ? "Username" : "ชื่อผู้ใช้"}
                </label>
                <Input
                  disabled={true}
                  id="CardEmployeeInformationUX-Input-249"
                  name="username"
                  onChange={props.onChangeValue}
                  value={props.username ?? ""}>
                </Input>
              </FormField>
            </FormGroup>
          </div>
          <Form
            id="CardEmployeeInformationUX-Form-275">
            <FormGroup
              id="CardEmployeeInformationUX-FormGroup-276"
              inline={true}
              style={{marginTop: "1.5rem"}}>
              <FormField
                id="CardEmployeeInformationUX-FormField-277"
                style={{flex:1}}>
              </FormField>
              <FormField
                id="CardEmployeeInformationUX-FormField-278">
                <Button
                  color="blue"
                  id="CardEmployeeInformationUX-Button-281"
                  onClick={props.onResetPassword}
                  size="small"
                  style={{display: props.basic?.id ? "" :"none", ...(props.config?.HIDE_RESET_PASSWORD_EMPLOYEE_INFORMATION && { display: "none" })}}>
                  {props.languageUX === "en" ? "Reset Password" : "รีเซ็ตรหัสผ่าน"}
                </Button>
              </FormField>
              <FormField
                id="CardEmployeeInformationUX-FormField-279">
                {}
                <div
                  id="CardEmployeeInformationUX-div-280">
                  {props.buttonSave}
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
      </div>
    )
}


export default CardEmployeeInformationUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Wed Jan 07 2026 16:00:34 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", marginTop: \".5em\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Form",
      "parent": 310,
      "props": {
        "className": {
          "type": "value",
          "value": "--override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Form-1"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-2"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormField",
      "parent": 2,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.code ? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-3"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "label",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสพนักงาน",
          "valueEN": "Employee Code"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-4"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "Input",
      "parent": 3,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-5"
        },
        "name": {
          "type": "value",
          "value": "basic.code"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.basic?.code?? \"\""
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormGroup",
      "parent": 312,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\", display: props.filteredSectionList?.includes(\"Basic Employee Information\")?\"\":\"none\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding:0}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "label",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "ข้อมูลพื้นฐานพนักงาน",
          "valueEN": "Basic Employee Information"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-8"
        },
        "style": {
          "type": "code",
          "value": "{color: \"rgba(26, 115, 232, 1)\", fontSize: \"0.95rem\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 311,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form --override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"rgba(240, 249, 252, 1)\", padding: \"1rem 10px\",display: props.filteredSectionList?.includes(\"Basic Employee Information\")?\"\":\"none\"}"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormGroup",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-10"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 10,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-11"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "label",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": "เอกสารแสดงตัวตน",
          "valueEN": "Identity Document"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-12"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "Dropdown",
      "parent": 11,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Dropdown-13"
        },
        "name": {
          "type": "value",
          "value": "basic.citizen_type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.idOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.basic?.citizen_type ?? \"\""
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormGroup",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-14"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "FormField",
      "parent": 14,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-15"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "label",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ (ภาษาไทย)",
          "valueEN": "Name (in Thai)"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-16"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "FormGroup",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-17"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "FormField",
      "parent": 17,
      "props": {
        "className": {
          "type": "code",
          "value": "props.basic?.citizen_type===\"T\"?`required ${props.showRequiredField?.pre_name? \"error\" : \"\"}`:\"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-18"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "FormField",
      "parent": 17,
      "props": {
        "className": {
          "type": "code",
          "value": "props.basic?.citizen_type===\"T\"?`required ${props.showRequiredField?.first_name? \"error\" : \"\"}`:\"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-19"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormField",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-20"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormField",
      "parent": 17,
      "props": {
        "className": {
          "type": "code",
          "value": "props.basic?.citizen_type===\"T\"?`required ${props.showRequiredField?.last_name? \"error\" : \"\"}`:\"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-21"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormField",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-22"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "label",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อก่อน",
          "valueEN": "Pre name"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-23"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "label",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อจริง",
          "valueEN": "First name"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-24"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\"}"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "label",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อกลาง",
          "valueEN": "Middle name"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-25"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "label",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": "นามสกุล",
          "valueEN": "Last name"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-26"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\"}"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "label",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อเล่น",
          "valueEN": "Nick name"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-27"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\"}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "Dropdown",
      "parent": 18,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Dropdown-28"
        },
        "name": {
          "type": "value",
          "value": "basic.pre_name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.prenameThOptions"
        },
        "placeholder": {
          "type": "code",
          "value": ""
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.basic?.pre_name ?? \"\""
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "Input",
      "parent": 19,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-29"
        },
        "name": {
          "type": "value",
          "value": "basic.first_name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.basic?.first_name ?? \"\""
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "Input",
      "parent": 20,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-30"
        },
        "name": {
          "type": "value",
          "value": "basic.middle_name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "readOnly": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.basic?.middle_name ?? \"\""
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "Input",
      "parent": 21,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-31"
        },
        "name": {
          "type": "value",
          "value": "basic.last_name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.basic?.last_name ?? \"\""
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "Input",
      "parent": 22,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-32"
        },
        "name": {
          "type": "value",
          "value": "basic.nick_name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.basic?.nick_name ?? \"\""
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "FormGroup",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-33"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "FormGroup",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-34"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "FormField",
      "parent": 33,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-35"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "label",
      "parent": 35,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ (ภาษาอังกฤษ)",
          "valueEN": "Name (in English)"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-36"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "FormField",
      "parent": 34,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.pre_name_en? \"error\":\"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-37"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "FormField",
      "parent": 34,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.first_name_en? \"error\":\"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-38"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "FormField",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-39"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "FormField",
      "parent": 34,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.last_name_en? \"error\":\"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-40"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormField",
      "parent": 34,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-41"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "label",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อก่อน",
          "valueEN": "Pre name"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-42"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "label",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อจริง",
          "valueEN": "First name"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-43"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "label",
      "parent": 39,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อกลาง",
          "valueEN": "Middle name"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-44"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\"}"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "label",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "นามสกุล",
          "valueEN": "Last name"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-45"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\"}"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "label",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อเล่น",
          "valueEN": "Nick name"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-46"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "Dropdown",
      "parent": 37,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Dropdown-47"
        },
        "name": {
          "type": "value",
          "value": "basic.pre_name_en"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.prenameEnOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.basic?.pre_name_en ?? \"\""
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "Input",
      "parent": 38,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-48"
        },
        "name": {
          "type": "value",
          "value": "basic.first_name_en"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.basic?.first_name_en ?? \"\""
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "Input",
      "parent": 39,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-49"
        },
        "name": {
          "type": "value",
          "value": "basic.middle_name_en"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.basic?.middle_name_en ?? \"\""
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "Input",
      "parent": 40,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-50"
        },
        "name": {
          "type": "value",
          "value": "basic.last_name_en"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.basic?.last_name_en ?? \"\""
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "Input",
      "parent": 41,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-51"
        },
        "name": {
          "type": "value",
          "value": "basic.nick_name_en"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.basic?.nick_name_en ?? \"\""
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "FormGroup",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-52"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0\"}"
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "FormField",
      "parent": 52,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-53"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "14"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "FormField",
      "parent": 310,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-54"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 71,
      "name": "FormGroup",
      "parent": 53,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-71"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 72,
      "name": "FormField",
      "parent": 71,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.birth_date ? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-72"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 73,
      "name": "FormField",
      "parent": 71,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-73"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 74,
      "name": "FormField",
      "parent": 71,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.nationality? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-74"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 75,
      "name": "FormField",
      "parent": 71,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.religion? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-75"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "Dropdown",
      "parent": 74,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Dropdown-78"
        },
        "name": {
          "type": "value",
          "value": "basic.nationality"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.nationalityOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.basic?.nationality ?? \"\""
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 79,
      "name": "Dropdown",
      "parent": 75,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Dropdown-79"
        },
        "name": {
          "type": "value",
          "value": "basic.religion"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.religionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.basic?.religion ?? \"\""
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "label",
      "parent": 75,
      "props": {
        "children": {
          "type": "value",
          "value": "ศาสนา",
          "valueEN": "Religion"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-80"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "label",
      "parent": 74,
      "props": {
        "children": {
          "type": "value",
          "value": "สัญชาติ",
          "valueEN": "Nationality"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-81"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "label",
      "parent": 73,
      "props": {
        "children": {
          "type": "value",
          "value": "อายุ",
          "valueEN": "Age"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-82"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "label",
      "parent": 72,
      "props": {
        "children": {
          "type": "value",
          "value": "วันเกิด",
          "valueEN": "Date of Birth"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-83"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"107px\"}"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "Input",
      "parent": 73,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-84"
        },
        "value": {
          "type": "code",
          "value": "props.age"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "div",
      "parent": 72,
      "props": {
        "children": {
          "type": "code",
          "value": "props.birthDate"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-85"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "FormGroup",
      "parent": 53,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-87"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 88,
      "name": "FormField",
      "parent": 87,
      "props": {
        "className": {
          "type": "code",
          "value": "props.basic?.citizen_type===\"T\"?`required ${props.showRequiredField?.citizen_no ? \"error\" : \"\"}`:\"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-88"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 89,
      "name": "FormField",
      "parent": 87,
      "props": {
        "className": {
          "type": "code",
          "value": "props.basic?.citizen_type===\"F\"?`required ${props.showRequiredField?.passport_no? \"error\" : \"\"}`:\"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-89"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "label",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเลขบัตรประชาชน",
          "valueEN": "ID card Number"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-90"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"107px\"}"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": null,
      "id": 91,
      "name": "label",
      "parent": 89,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเลขหนังสือเดินทาง",
          "valueEN": "Passport Number"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-91"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 93,
      "name": "Input",
      "parent": 89,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-93"
        },
        "name": {
          "type": "value",
          "value": "basic.passport_no"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.basic?.passport_no ?? \"\""
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 54,
      "props": {
        "children": {
          "type": "code",
          "value": "props.profileImage"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-94"
        },
        "style": {
          "type": "code",
          "value": "{ marginBottom: \"24px\" }"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "FormGroup",
      "parent": 53,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-95"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 96,
      "name": "FormField",
      "parent": 95,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.phone_no? \"error\":\"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-96"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 97,
      "name": "FormField",
      "parent": 95,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.email? \"error\":\"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-97"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 98,
      "name": "FormField",
      "parent": 95,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-98"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 99,
      "name": "label",
      "parent": 96,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเลขโทรศัพท์มือถือ",
          "valueEN": "Mobile Number"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-99"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"107px\"}"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": null,
      "id": 100,
      "name": "label",
      "parent": 97,
      "props": {
        "children": {
          "type": "value",
          "value": "อีเมล",
          "valueEN": "E-mail"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-100"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "label",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": "ไลน์ไอดี",
          "valueEN": "Line ID"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-101"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "Input",
      "parent": 96,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-102"
        },
        "name": {
          "type": "value",
          "value": "basic.phone_no"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.basic?.phone_no?? \"\""
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "Input",
      "parent": 97,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-103"
        },
        "name": {
          "type": "value",
          "value": "basic.email"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.basic?.email ?? \"\""
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 104,
      "name": "Input",
      "parent": 98,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-104"
        },
        "name": {
          "type": "value",
          "value": "basic.line_id"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.basic?.line_id ?? \"\""
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": null,
      "id": 105,
      "name": "div",
      "parent": 311,
      "props": {
        "children": {
          "type": "value",
          "value": "ข้อมูลส่วนบุคคล",
          "valueEN": "Personal Information"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-105"
        },
        "style": {
          "type": "code",
          "value": "{color: \"rgba(26, 115, 232, 1)\", fontSize: \"0.95rem\", margin: \"1rem 0 0.5rem\", fontWeight: \"bold\",display: props.filteredSectionList?.includes(\"Personal Information\")?\"\":\"none\"}"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "div",
      "parent": 311,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form --override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-106"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"rgba(240, 249, 252, 1)\", padding: \"1rem 10px\",display: props.filteredSectionList?.includes(\"Personal Information\")?\"\":\"none\"}"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 107,
      "name": "FormGroup",
      "parent": 106,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-107"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: 0}"
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 108,
      "name": "FormField",
      "parent": 107,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-108"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "14"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 109,
      "name": "FormField",
      "parent": 107,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-109"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "FormGroup",
      "parent": 108,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-110"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "FormField",
      "parent": 110,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.marital_status? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-111"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 112,
      "name": "FormField",
      "parent": 110,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-112"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": null,
      "id": 113,
      "name": "label",
      "parent": 111,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานภาพสมรส",
          "valueEN": "Marital Status"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-113"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"105px\"}"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": null,
      "id": 114,
      "name": "label",
      "parent": 112,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อคู่สมรส",
          "valueEN": "Spouse’s Name"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-114"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "Dropdown",
      "parent": 111,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Dropdown-115"
        },
        "name": {
          "type": "value",
          "value": "personal.marital_status"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.maritalStatusOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.personal?.marital_status ?? \"\""
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 116,
      "name": "Input",
      "parent": 112,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.isSingle || props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-116"
        },
        "name": {
          "type": "value",
          "value": "name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeSpouseName"
        },
        "value": {
          "type": "code",
          "value": "props.spouseName ?? \"\""
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": null,
      "id": 117,
      "name": "div",
      "parent": 108,
      "props": {
        "children": {
          "type": "code",
          "value": "props.childrenList"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-117"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": null,
      "id": 118,
      "name": "div",
      "parent": 311,
      "props": {
        "children": {
          "type": "value",
          "value": "ที่อยู่บนบัตรประจำตัวประชาชน",
          "valueEN": "Address on ID Card"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-118"
        },
        "style": {
          "type": "code",
          "value": "{color: \"rgba(26, 115, 232, 1)\", fontSize: \"0.95rem\", margin: \"1rem 0 0.5rem\", fontWeight: \"bold\",display: props.filteredSectionList?.includes(\"Address on ID Card\")?\"\":\"none\"}"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": null,
      "id": 119,
      "name": "div",
      "parent": 311,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form --override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-119"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"rgba(240, 249, 252, 1)\", padding: \"1rem 10px\",display: props.filteredSectionList?.includes(\"Address on ID Card\")?\"\":\"none\"}"
        }
      },
      "seq": 193,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 120,
      "name": "FormGroup",
      "parent": 119,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-120"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 121,
      "name": "FormGroup",
      "parent": 119,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-121"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: 0}"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 122,
      "name": "FormField",
      "parent": 120,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.id_card_address?.no? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-122"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 123,
      "name": "FormField",
      "parent": 120,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-123"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 124,
      "name": "FormField",
      "parent": 120,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-124"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 125,
      "name": "FormField",
      "parent": 120,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-125"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 126,
      "name": "FormField",
      "parent": 120,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.id_card_address?.road? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-126"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 127,
      "name": "FormField",
      "parent": 121,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.id_card_address?.city? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-127"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 128,
      "name": "FormField",
      "parent": 121,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.id_card_address?.district? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-128"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 129,
      "name": "FormField",
      "parent": 121,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.id_card_address?.province? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-129"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 130,
      "name": "FormField",
      "parent": 121,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.id_card_address?.zipcode? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-130"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "label",
      "parent": 122,
      "props": {
        "children": {
          "type": "value",
          "value": "บ้านเลขที่",
          "valueEN": "House number"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-131"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"105px\"}"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": null,
      "id": 132,
      "name": "label",
      "parent": 123,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อหมู่บ้าน",
          "valueEN": "Village name"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-132"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": null,
      "id": 133,
      "name": "label",
      "parent": 124,
      "props": {
        "children": {
          "type": "value",
          "value": "ซอย",
          "valueEN": "Alley/Soi"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-133"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": null,
      "id": 134,
      "name": "label",
      "parent": 125,
      "props": {
        "children": {
          "type": "value",
          "value": "จุดตัด",
          "valueEN": "Intersection"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-134"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": null,
      "id": 135,
      "name": "label",
      "parent": 126,
      "props": {
        "children": {
          "type": "value",
          "value": "ถนน",
          "valueEN": "Street"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-135"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "label",
      "parent": 127,
      "props": {
        "children": {
          "type": "value",
          "value": "ตำบล/เขต",
          "valueEN": "Sub-district/Sub-area"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-136"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": null,
      "id": 137,
      "name": "label",
      "parent": 128,
      "props": {
        "children": {
          "type": "value",
          "value": "เขต/พื้นที่",
          "valueEN": "District/Area"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-137"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": null,
      "id": 138,
      "name": "label",
      "parent": 129,
      "props": {
        "children": {
          "type": "value",
          "value": "จังหวัด",
          "valueEN": "Province"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-138"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "label",
      "parent": 130,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสไปรษณีย์",
          "valueEN": "Postal Code"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-139"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 140,
      "name": "Input",
      "parent": 122,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-140"
        },
        "name": {
          "type": "value",
          "value": "id_card_address.no"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.idCardAddress?.no?? \"\""
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 141,
      "name": "Input",
      "parent": 123,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-141"
        },
        "name": {
          "type": "value",
          "value": "id_card_address.name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.idCardAddress?.name?? \"\""
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 142,
      "name": "Input",
      "parent": 124,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-142"
        },
        "name": {
          "type": "value",
          "value": "id_card_address.street"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.idCardAddress?.street?? \"\""
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 143,
      "name": "Input",
      "parent": 125,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-143"
        },
        "name": {
          "type": "value",
          "value": "id_card_address.substreet"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.idCardAddress?.substreet?? \"\""
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "Input",
      "parent": 126,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-144"
        },
        "name": {
          "type": "value",
          "value": "id_card_address.road"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.idCardAddress?.road?? \"\""
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "Input",
      "parent": 130,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-145"
        },
        "name": {
          "type": "value",
          "value": "id_card_address.zipcode"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.idCardAddress?.zipcode?? \"\""
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 146,
      "name": "Dropdown",
      "parent": 127,
      "props": {
        "className": {
          "type": "code",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Dropdown-146"
        },
        "name": {
          "type": "value",
          "value": "id_card_address.city"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.idCardCityOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.idCardAddress?.city?? \"\""
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 147,
      "name": "Dropdown",
      "parent": 128,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Dropdown-147"
        },
        "name": {
          "type": "value",
          "value": "id_card_address.district"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.idCardDistrictOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.idCardAddress?.district?? \"\""
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 148,
      "name": "Dropdown",
      "parent": 129,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Dropdown-148"
        },
        "name": {
          "type": "value",
          "value": "id_card_address.province"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.provinceOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.idCardAddress?.province?? \"\""
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": null,
      "id": 149,
      "name": "div",
      "parent": 311,
      "props": {
        "children": {
          "type": "value",
          "value": "ข้อมูลการติดต่อ",
          "valueEN": "Contact Information"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-149"
        },
        "style": {
          "type": "code",
          "value": "{color: \"rgba(26, 115, 232, 1)\", fontSize: \"0.95rem\", margin: \"1rem 0 0.5rem\", fontWeight: \"bold\",display: props.filteredSectionList?.includes(\"Contact Information\")?\"\":\"none\"}"
        }
      },
      "seq": 194,
      "void": false
    },
    {
      "from": null,
      "id": 150,
      "name": "div",
      "parent": 311,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form --override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-150"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"rgba(240, 249, 252, 1)\", padding: \"1rem 10px\",display: props.filteredSectionList?.includes(\"Contact Information\")?\"\":\"none\"}"
        }
      },
      "seq": 244,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 151,
      "name": "FormGroup",
      "parent": 150,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-151"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.25rem\"}"
        }
      },
      "seq": 151,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 152,
      "name": "FormGroup",
      "parent": 150,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-152"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 153,
      "name": "FormGroup",
      "parent": 150,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-153"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 154,
      "name": "FormGroup",
      "parent": 150,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-154"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: 0}"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 155,
      "name": "FormField",
      "parent": 151,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-155"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 156,
      "name": "FormField",
      "parent": 152,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.contact_address?.no? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-156"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 157,
      "name": "FormField",
      "parent": 152,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-157"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 158,
      "name": "FormField",
      "parent": 152,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-158"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 159,
      "name": "FormField",
      "parent": 152,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-159"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 160,
      "name": "FormField",
      "parent": 152,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.contact_address?.road? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-160"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 161,
      "name": "FormField",
      "parent": 153,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.contact_address?.city? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-161"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 162,
      "name": "FormField",
      "parent": 153,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.contact_address?.district? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-162"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 163,
      "name": "FormField",
      "parent": 153,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.contact_address?.province? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-163"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 164,
      "name": "FormField",
      "parent": 153,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.contact_address?.zipcode? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-164"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 165,
      "name": "FormField",
      "parent": 154,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.contact_address?.emergency_contact_name? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-165"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 166,
      "name": "FormField",
      "parent": 154,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.contact_address?.emergency_contact_tel? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-166"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": null,
      "id": 167,
      "name": "label",
      "parent": 155,
      "props": {
        "children": {
          "type": "value",
          "value": "ที่อยู่ปัจจุบัน",
          "valueEN": "Current Address"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-167"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": null,
      "id": 168,
      "name": "label",
      "parent": 156,
      "props": {
        "children": {
          "type": "value",
          "value": "บ้านเลขที่",
          "valueEN": "House number"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-168"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": null,
      "id": 169,
      "name": "label",
      "parent": 157,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อหมู่บ้าน",
          "valueEN": "Village name"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-169"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": null,
      "id": 170,
      "name": "label",
      "parent": 158,
      "props": {
        "children": {
          "type": "value",
          "value": "ซอย",
          "valueEN": "Alley/Soi"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-170"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 170,
      "void": false
    },
    {
      "from": null,
      "id": 171,
      "name": "label",
      "parent": 159,
      "props": {
        "children": {
          "type": "value",
          "value": "จุดตัด",
          "valueEN": "Intersection"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-171"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": null,
      "id": 172,
      "name": "label",
      "parent": 160,
      "props": {
        "children": {
          "type": "value",
          "value": "ถนน",
          "valueEN": "Street"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-172"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": null,
      "id": 173,
      "name": "label",
      "parent": 161,
      "props": {
        "children": {
          "type": "value",
          "value": "ตำบล/เขต",
          "valueEN": "Sub-district/Sub-area"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-173"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": null,
      "id": 174,
      "name": "label",
      "parent": 162,
      "props": {
        "children": {
          "type": "value",
          "value": "เขต/พื้นที่",
          "valueEN": "District/Area"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-174"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": null,
      "id": 175,
      "name": "label",
      "parent": 163,
      "props": {
        "children": {
          "type": "value",
          "value": "จังหวัด",
          "valueEN": "Province"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-175"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": null,
      "id": 176,
      "name": "label",
      "parent": 164,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสไปรษณีย์",
          "valueEN": "Postal Code"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-176"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": null,
      "id": 177,
      "name": "label",
      "parent": 165,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อผู้ติดต่อฉุกเฉิน",
          "valueEN": "Emergency Contact Name"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-177"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": null,
      "id": 178,
      "name": "label",
      "parent": 166,
      "props": {
        "children": {
          "type": "value",
          "value": "เบอร์ติดต่อฉุกเฉิน",
          "valueEN": "Emergency Contact Number"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-178"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 179,
      "name": "FormField",
      "parent": 151,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-179"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 179,
      "void": false
    },
    {
      "from": null,
      "id": 181,
      "name": "div",
      "parent": 179,
      "props": {
        "children": {
          "type": "code",
          "value": "props.currentAddress"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-181"
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 182,
      "name": "Input",
      "parent": 156,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!!props.contactAddress?.use_id_card_address_as_contact || props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-182"
        },
        "name": {
          "type": "value",
          "value": "contact_address.no"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.contactAddress?.no?? \"\""
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 183,
      "name": "Input",
      "parent": 157,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!!props.contactAddress?.use_id_card_address_as_contact|| props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-183"
        },
        "name": {
          "type": "value",
          "value": "contact_address.name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.contactAddress?.name?? \"\""
        }
      },
      "seq": 183,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 184,
      "name": "Input",
      "parent": 158,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!!props.contactAddress?.use_id_card_address_as_contact|| props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-184"
        },
        "name": {
          "type": "value",
          "value": "contact_address.street"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.contactAddress?.street?? \"\""
        }
      },
      "seq": 184,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 185,
      "name": "Input",
      "parent": 159,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!!props.contactAddress?.use_id_card_address_as_contact|| props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-185"
        },
        "name": {
          "type": "value",
          "value": "contact_address.substreet"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.contactAddress?.substreet?? \"\""
        }
      },
      "seq": 185,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 186,
      "name": "Input",
      "parent": 160,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!!props.contactAddress?.use_id_card_address_as_contact|| props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-186"
        },
        "name": {
          "type": "value",
          "value": "contact_address.road"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.contactAddress?.road?? \"\""
        }
      },
      "seq": 186,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 187,
      "name": "Input",
      "parent": 164,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!!props.contactAddress?.use_id_card_address_as_contact||props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-187"
        },
        "loading": {
          "type": "code",
          "value": ""
        },
        "name": {
          "type": "value",
          "value": "contact_address.zipcode"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.contactAddress?.zipcode?? \"\""
        }
      },
      "seq": 187,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 188,
      "name": "Dropdown",
      "parent": 163,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!!props.contactAddress?.use_id_card_address_as_contact||props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Dropdown-188"
        },
        "name": {
          "type": "value",
          "value": "contact_address.province"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.provinceOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.contactAddress?.province?? \"\""
        }
      },
      "seq": 188,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 189,
      "name": "Dropdown",
      "parent": 162,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!!props.contactAddress?.use_id_card_address_as_contact||props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Dropdown-189"
        },
        "name": {
          "type": "value",
          "value": "contact_address.district"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.contactDistrictOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.contactAddress?.district?? \"\""
        }
      },
      "seq": 189,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 190,
      "name": "Dropdown",
      "parent": 161,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!!props.contactAddress?.use_id_card_address_as_contact||props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Dropdown-190"
        },
        "name": {
          "type": "value",
          "value": "contact_address.city"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.contactCityOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.contactAddress?.city?? \"\""
        }
      },
      "seq": 190,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 191,
      "name": "Input",
      "parent": 166,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-191"
        },
        "name": {
          "type": "value",
          "value": "contact_address.emergency_contact_tel"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.contactAddress?.emergency_contact_tel?? \"\""
        }
      },
      "seq": 191,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 192,
      "name": "Input",
      "parent": 165,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-192"
        },
        "name": {
          "type": "value",
          "value": "contact_address.emergency_contact_name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.contactAddress?.emergency_contact_name?? \"\""
        }
      },
      "seq": 192,
      "void": false
    },
    {
      "from": null,
      "id": 193,
      "name": "div",
      "parent": 311,
      "props": {
        "children": {
          "type": "value",
          "value": "ข้อมูลการจ้างงาน",
          "valueEN": "Employment Information"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-193"
        },
        "style": {
          "type": "code",
          "value": "{color: \"rgba(26, 115, 232, 1)\", fontSize: \"0.95rem\", margin: \"1rem 0 0.5rem\", fontWeight: \"bold\",display: props.filteredSectionList?.includes(\"Employment Information\")?\"\":\"none\"}"
        }
      },
      "seq": 245,
      "void": false
    },
    {
      "from": null,
      "id": 194,
      "name": "div",
      "parent": 311,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form --override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-194"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"rgba(240, 249, 252, 1)\", padding: \"1rem 10px\",display: props.filteredSectionList?.includes(\"Employment Information\")?\"\":\"none\"}"
        }
      },
      "seq": 275,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 195,
      "name": "FormGroup",
      "parent": 194,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-195"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 195,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 196,
      "name": "FormField",
      "parent": 195,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.affiliate ? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-196"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 196,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 197,
      "name": "FormField",
      "parent": 313,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-197"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 202,
      "void": false
    },
    {
      "from": null,
      "id": 198,
      "name": "label",
      "parent": 196,
      "props": {
        "children": {
          "type": "value",
          "value": "สังกัด",
          "valueEN": "Affiliation"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-198"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"75px\", maxWidth: \"75px\"}"
        }
      },
      "seq": 198,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 200,
      "name": "Checkbox",
      "parent": 197,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.employment?.isManager ?? false"
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Checkbox-200"
        },
        "label": {
          "type": "value",
          "value": "เป็นผู้จัดการ",
          "valueEN": "Is Manager"
        },
        "name": {
          "type": "value",
          "value": "employment.isManager"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"bold\"}"
        }
      },
      "seq": 200,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 201,
      "name": "Dropdown",
      "parent": 197,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.employment?.isManager||props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Dropdown-201"
        },
        "name": {
          "type": "value",
          "value": "employment.managed_division"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.managementOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.employment?.managed_division??\"\""
        }
      },
      "seq": 201,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 202,
      "name": "FormField",
      "parent": 195,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.employment_type ? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-202"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 313,
      "void": false
    },
    {
      "from": null,
      "id": 203,
      "name": "label",
      "parent": 202,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทการจ้างงาน",
          "valueEN": "Employment type"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-203"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 203,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 204,
      "name": "Dropdown",
      "parent": 202,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Dropdown-204"
        },
        "name": {
          "type": "value",
          "value": "employment.employment_type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.employmentTypeOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.employment?.employment_type ?? \"\""
        }
      },
      "seq": 204,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 205,
      "name": "FormGroup",
      "parent": 194,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-205"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 205,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 206,
      "name": "FormField",
      "parent": 205,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.position? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-206"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 206,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 207,
      "name": "FormField",
      "parent": 205,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-207"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"2.4em\"}"
        },
        "width": {
          "type": "code",
          "value": "13"
        }
      },
      "seq": 267,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 208,
      "name": "FormGroup",
      "parent": 207,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-208"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 209,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 209,
      "name": "FormGroup",
      "parent": 207,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-209"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", marginBottom: 0}"
        }
      },
      "seq": 211,
      "void": false
    },
    {
      "from": null,
      "id": 210,
      "name": "label",
      "parent": 206,
      "props": {
        "children": {
          "type": "value",
          "value": "ตำแหน่ง",
          "valueEN": "Position"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-210"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"75px\", maxWidth: \"75px\", marginTop: \"0.65rem\"}"
        }
      },
      "seq": 207,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 211,
      "name": "Dropdown",
      "parent": 206,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Dropdown-211"
        },
        "name": {
          "type": "value",
          "value": "employment.position"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.positionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.employment?.position?? \"\""
        }
      },
      "seq": 208,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 212,
      "name": "FormField",
      "parent": 208,
      "props": {
        "className": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-212"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: \"0\"}"
        }
      },
      "seq": 212,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 213,
      "name": "FormField",
      "parent": 208,
      "props": {
        "className": {
          "type": "code",
          "value": "`${props.employment?.isNoneDoctor?\"required\":\"\"} ${props.showRequiredField?.licence? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-213"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 213,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 214,
      "name": "Checkbox",
      "parent": 212,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.employment?.isNoneDoctor?? false"
        },
        "disabled": {
          "type": "code",
          "value": "props.employment?.doctor_id||props.readOnly"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Checkbox-214"
        },
        "label": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "name": {
          "type": "value",
          "value": "employment.isNoneDoctor"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 214,
      "void": false
    },
    {
      "from": null,
      "id": 215,
      "name": "label",
      "parent": 213,
      "props": {
        "children": {
          "type": "value",
          "value": "ใบอนุญาตประกอบวิชาชีพ",
          "valueEN": "Professional License"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-215"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 215,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 216,
      "name": "Input",
      "parent": 213,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.employment?.isNoneDoctor||props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-216"
        },
        "name": {
          "type": "value",
          "value": "employment.licence"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.employment?.licence ?? \"\""
        }
      },
      "seq": 216,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 217,
      "name": "FormField",
      "parent": 209,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-217"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"2.4em\"}"
        }
      },
      "seq": 217,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 218,
      "name": "FormField",
      "parent": 209,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.certificate_no? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-218"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 218,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 219,
      "name": "FormField",
      "parent": 209,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.doctor_code ? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-219"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 219,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 220,
      "name": "FormField",
      "parent": 209,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.specialties? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-220"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 220,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 221,
      "name": "Checkbox",
      "parent": 217,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.employment?.isDoctor?? false"
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Checkbox-221"
        },
        "label": {
          "type": "value",
          "value": "เป็นหมอ",
          "valueEN": "Is Doctor"
        },
        "name": {
          "type": "value",
          "value": "employment.isDoctor"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 221,
      "void": false
    },
    {
      "from": null,
      "id": 222,
      "name": "label",
      "parent": 220,
      "props": {
        "children": {
          "type": "value",
          "value": "ความเชี่ยวชาญ",
          "valueEN": "Specialty"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-222"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 222,
      "void": false
    },
    {
      "from": null,
      "id": 223,
      "name": "label",
      "parent": 219,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสแพทย์",
          "valueEN": "Doctor code"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-223"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 223,
      "void": false
    },
    {
      "from": null,
      "id": 224,
      "name": "label",
      "parent": 218,
      "props": {
        "children": {
          "type": "value",
          "value": "ใบอนุญาตประกอบวิชาชีพแพทย์",
          "valueEN": "Medical license"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-224"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 224,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 225,
      "name": "Input",
      "parent": 218,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.employment?.isNoneDoctor || !props.employment?.isDoctor ||props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-225"
        },
        "name": {
          "type": "value",
          "value": "employment.certificate_no"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.employment?.certificate_no ?? \"\""
        }
      },
      "seq": 225,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 226,
      "name": "Input",
      "parent": 219,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.employment?.isNoneDoctor || !props.employment?.isDoctor || props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-226"
        },
        "name": {
          "type": "value",
          "value": "employment.doctor_code"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.employment?.doctor_code?? \"\""
        }
      },
      "seq": 226,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 227,
      "name": "Dropdown",
      "parent": 220,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.employment?.isNoneDoctor || !props.employment?.isDoctor || props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Dropdown-227"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "employment.specialties"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.specialtyOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.employment?.specialties?? \"\""
        }
      },
      "seq": 227,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 228,
      "name": "FormGroup",
      "parent": 194,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-228"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 228,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 229,
      "name": "FormField",
      "parent": 228,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.flag_start_date? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-229"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 229,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 230,
      "name": "FormField",
      "parent": 228,
      "props": {
        "className": {
          "type": "code",
          "value": "`required ${props.showRequiredField?.flag_end_date? \"error\" : \"\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-230"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 230,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 231,
      "name": "FormField",
      "parent": 228,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-231"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 231,
      "void": false
    },
    {
      "from": null,
      "id": 232,
      "name": "label",
      "parent": 229,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่เริ่มงาน",
          "valueEN": "Employment start date"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-232"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 232,
      "void": false
    },
    {
      "from": null,
      "id": 233,
      "name": "label",
      "parent": 230,
      "props": {
        "children": {
          "type": "value",
          "value": "วันสิ้นสุดการจ้างงาน",
          "valueEN": "Employment end date"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-233"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 233,
      "void": false
    },
    {
      "from": null,
      "id": 234,
      "name": "label",
      "parent": 231,
      "props": {
        "children": {
          "type": "value",
          "value": "เหตุผล",
          "valueEN": "Reason"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-234"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 234,
      "void": false
    },
    {
      "from": null,
      "id": 235,
      "name": "div",
      "parent": 229,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-235"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 235,
      "void": false
    },
    {
      "from": null,
      "id": 236,
      "name": "div",
      "parent": 230,
      "props": {
        "children": {
          "type": "code",
          "value": "props.flagEndDate"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-236"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 236,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 237,
      "name": "Input",
      "parent": 231,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-237"
        },
        "name": {
          "type": "value",
          "value": "employment.inactive_reason"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.employment?.inactive_reason ?? \"\""
        }
      },
      "seq": 237,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 238,
      "name": "DateTextBox",
      "parent": 235,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-DateTextBox-238"
        },
        "onChange": {
          "type": "code",
          "value": "(value: any)=>props.onChangeValue?.(null,{name:\"employment.flag_start_date\", value})"
        },
        "style": {
          "type": "code",
          "value": "{color: \"rgba(0,0,0,.87)\"}"
        },
        "value": {
          "type": "code",
          "value": "props.employment?.flag_start_date?? \"\""
        }
      },
      "seq": 238,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 240,
      "name": "FormGroup",
      "parent": 194,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-240"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: 0}"
        }
      },
      "seq": 240,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 241,
      "name": "FormField",
      "parent": 240,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-241"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 241,
      "void": false
    },
    {
      "from": null,
      "id": 242,
      "name": "label",
      "parent": 241,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะพนักงานปัจจุบัน",
          "valueEN": "Current employee status"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-242"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 242,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 243,
      "name": "Dropdown",
      "parent": 241,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Dropdown-243"
        },
        "name": {
          "type": "value",
          "value": "employment.current_status"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.currentEmpStatusOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.employment?.current_status || \"\""
        }
      },
      "seq": 243,
      "void": false
    },
    {
      "from": null,
      "id": 244,
      "name": "div",
      "parent": 311,
      "props": {
        "children": {
          "type": "value",
          "value": "สร้างผู้ใช้สำหรับการเข้าถึงระบบ",
          "valueEN": "Create a user for system access"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-244"
        },
        "style": {
          "type": "code",
          "value": "{color: \"rgba(26, 115, 232, 1)\", fontSize: \"0.95rem\", margin: \"1rem 0 0.5rem\", fontWeight: \"bold\", display: props.readOnly?\"none\":props.filteredSectionList?.includes(\"Create a user for system access\")?\"\":\"none\"}"
        }
      },
      "seq": 310,
      "void": false
    },
    {
      "from": null,
      "id": 245,
      "name": "div",
      "parent": 311,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form --override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-245"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"rgba(240, 249, 252, 1)\", padding: \"1rem 10px\", display: props.readOnly?\"none\":props.filteredSectionList?.includes(\"Create a user for system access\")?\"\":\"none\"}"
        }
      },
      "seq": 311,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 246,
      "name": "FormGroup",
      "parent": 245,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-246"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: 0}"
        }
      },
      "seq": 246,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 247,
      "name": "FormField",
      "parent": 246,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-247"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 247,
      "void": false
    },
    {
      "from": null,
      "id": 248,
      "name": "label",
      "parent": 247,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อผู้ใช้",
          "valueEN": "Username"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-248"
        }
      },
      "seq": 248,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 249,
      "name": "Input",
      "parent": 247,
      "props": {
        "disabled": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Input-249"
        },
        "name": {
          "type": "value",
          "value": "username"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "readOnly": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.username ?? \"\""
        }
      },
      "seq": 249,
      "void": false
    },
    {
      "from": null,
      "id": 252,
      "name": "div",
      "parent": 196,
      "props": {
        "children": {
          "type": "code",
          "value": "props.affiliationSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-252"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 252,
      "void": false
    },
    {
      "from": null,
      "id": 253,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.code|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-253"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 253,
      "void": false
    },
    {
      "from": null,
      "id": 254,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "code",
          "value": "props.basic?.citizen_type===\"T\"?props.showRequiredField?.pre_name|| \"\":\"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-254"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 254,
      "void": false
    },
    {
      "from": null,
      "id": 255,
      "name": "div",
      "parent": 19,
      "props": {
        "children": {
          "type": "code",
          "value": "props.basic?.citizen_type===\"T\"?props.showRequiredField?.first_name|| \"\":\"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-255"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 255,
      "void": false
    },
    {
      "from": null,
      "id": 256,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "code",
          "value": "props.basic?.citizen_type===\"T\"?props.showRequiredField?.last_name|| \"\":\"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-256"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 256,
      "void": false
    },
    {
      "from": null,
      "id": 257,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.pre_name_en|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-257"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 257,
      "void": false
    },
    {
      "from": null,
      "id": 258,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.first_name_en|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-258"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 258,
      "void": false
    },
    {
      "from": null,
      "id": 259,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.last_name_en|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-259"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 259,
      "void": false
    },
    {
      "from": null,
      "id": 260,
      "name": "div",
      "parent": 72,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.birth_date|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-260"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 260,
      "void": false
    },
    {
      "from": null,
      "id": 261,
      "name": "div",
      "parent": 74,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.nationality|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-261"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 261,
      "void": false
    },
    {
      "from": null,
      "id": 262,
      "name": "div",
      "parent": 75,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.religion|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-262"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 262,
      "void": false
    },
    {
      "from": null,
      "id": 263,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "code",
          "value": "props.basic?.citizen_type===\"T\"?props.showRequiredField?.citizen_no || \"\":\"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-263"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 282,
      "void": false
    },
    {
      "from": null,
      "id": 264,
      "name": "div",
      "parent": 89,
      "props": {
        "children": {
          "type": "code",
          "value": "props.basic?.citizen_type===\"F\"?props.showRequiredField?.passport_no|| \"\":\"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-264"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 264,
      "void": false
    },
    {
      "from": null,
      "id": 265,
      "name": "div",
      "parent": 96,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.phone_no|| \"\""
        },
        "className": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-265"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 265,
      "void": false
    },
    {
      "from": null,
      "id": 266,
      "name": "div",
      "parent": 97,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.email|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-266"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 266,
      "void": false
    },
    {
      "from": null,
      "id": 267,
      "name": "div",
      "parent": 206,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.position|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-267"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", top: \"34px\", color: \"red\", fontSize: \"0.75rem\", right: \"7px\"}"
        }
      },
      "seq": 210,
      "void": false
    },
    {
      "from": null,
      "id": 268,
      "name": "div",
      "parent": 229,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.flag_start_date|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-268"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 268,
      "void": false
    },
    {
      "from": null,
      "id": 269,
      "name": "div",
      "parent": 230,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.flag_end_date|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-269"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 269,
      "void": false
    },
    {
      "from": null,
      "id": 270,
      "name": "div",
      "parent": 202,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.employment_type|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-270"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 270,
      "void": false
    },
    {
      "from": null,
      "id": 271,
      "name": "div",
      "parent": 111,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.marital_status|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-271"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 271,
      "void": false
    },
    {
      "from": null,
      "id": 272,
      "name": "div",
      "parent": 218,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.certificate_no|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-272"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 272,
      "void": false
    },
    {
      "from": null,
      "id": 273,
      "name": "div",
      "parent": 219,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.doctor_code|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-273"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 273,
      "void": false
    },
    {
      "from": null,
      "id": 274,
      "name": "div",
      "parent": 220,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.specialties|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-274"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 274,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 275,
      "name": "Form",
      "parent": 311,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Form-275"
        }
      },
      "seq": 312,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 276,
      "name": "FormGroup",
      "parent": 275,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-276"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1.5rem\"}"
        }
      },
      "seq": 276,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 277,
      "name": "FormField",
      "parent": 276,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-277"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 277,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 278,
      "name": "FormField",
      "parent": 276,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-278"
        }
      },
      "seq": 278,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 279,
      "name": "FormField",
      "parent": 276,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-279"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 279,
      "void": false
    },
    {
      "from": null,
      "id": 280,
      "name": "div",
      "parent": 279,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-280"
        }
      },
      "seq": 280,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 281,
      "name": "Button",
      "parent": 278,
      "props": {
        "children": {
          "type": "value",
          "value": "รีเซ็ตรหัสผ่าน",
          "valueEN": "Reset Password"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Button-281"
        },
        "onClick": {
          "type": "code",
          "value": "props.onResetPassword"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{display: props.basic?.id ? \"\" :\"none\", ...(props.config?.HIDE_RESET_PASSWORD_EMPLOYEE_INFORMATION && { display: \"none\" })}"
        }
      },
      "seq": 281,
      "void": false
    },
    {
      "from": null,
      "id": 282,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "code",
          "value": "props.basicMaskInput"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-282"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 263,
      "void": false
    },
    {
      "from": null,
      "id": 283,
      "name": "div",
      "parent": 196,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.affiliate|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-283"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 283,
      "void": false
    },
    {
      "from": null,
      "id": 284,
      "name": "div",
      "parent": 122,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.id_card_address?.no|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-284"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 284,
      "void": false
    },
    {
      "from": null,
      "id": 285,
      "name": "div",
      "parent": 126,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.id_card_address?.road|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-285"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 285,
      "void": false
    },
    {
      "from": null,
      "id": 286,
      "name": "div",
      "parent": 130,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.id_card_address?.zipcode|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-286"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 286,
      "void": false
    },
    {
      "from": null,
      "id": 287,
      "name": "div",
      "parent": 129,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.id_card_address?.province|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-287"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 287,
      "void": false
    },
    {
      "from": null,
      "id": 288,
      "name": "div",
      "parent": 128,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.id_card_address?.district|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-288"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 288,
      "void": false
    },
    {
      "from": null,
      "id": 289,
      "name": "div",
      "parent": 127,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.id_card_address?.city|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-289"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 289,
      "void": false
    },
    {
      "from": null,
      "id": 290,
      "name": "div",
      "parent": 166,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.contact_address?.emergency_contact_tel|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-290"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 290,
      "void": false
    },
    {
      "from": null,
      "id": 291,
      "name": "div",
      "parent": 165,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.contact_address?.emergency_contact_name|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-291"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 291,
      "void": false
    },
    {
      "from": null,
      "id": 292,
      "name": "div",
      "parent": 164,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.contact_address?.zipcode|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-292"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 292,
      "void": false
    },
    {
      "from": null,
      "id": 293,
      "name": "div",
      "parent": 163,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.contact_address?.province|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-293"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 293,
      "void": false
    },
    {
      "from": null,
      "id": 294,
      "name": "div",
      "parent": 162,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.contact_address?.district|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-294"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 294,
      "void": false
    },
    {
      "from": null,
      "id": 295,
      "name": "div",
      "parent": 161,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.contact_address?.city|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-295"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 295,
      "void": false
    },
    {
      "from": null,
      "id": 296,
      "name": "div",
      "parent": 160,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.contact_address?.road|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-296"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 296,
      "void": false
    },
    {
      "from": null,
      "id": 297,
      "name": "div",
      "parent": 156,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.contact_address?.no|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-297"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 297,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 298,
      "name": "FormField",
      "parent": 240,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormField-298"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 298,
      "void": false
    },
    {
      "from": null,
      "id": 299,
      "name": "label",
      "parent": 298,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะ",
          "valueEN": "Status"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-label-299"
        }
      },
      "seq": 299,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 300,
      "name": "Dropdown",
      "parent": 298,
      "props": {
        "defaultValue": {
          "type": "code",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "props.readOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-Dropdown-300"
        },
        "name": {
          "type": "value",
          "value": "employment.status"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.statusOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.employment?.status?? \"\""
        }
      },
      "seq": 300,
      "void": false
    },
    {
      "from": null,
      "id": 301,
      "name": "div",
      "parent": 213,
      "props": {
        "children": {
          "type": "code",
          "value": "props.showRequiredField?.licence|| \"\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-301"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", bottom: \"-16px\", color: \"red\", fontSize: \"0.75rem\", right: \"15px\"}"
        }
      },
      "seq": 301,
      "void": false
    },
    {
      "from": null,
      "id": 305,
      "name": "div",
      "parent": 311,
      "props": {
        "children": {
          "type": "code",
          "value": "props.educationInfo"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-306"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 305,
      "void": false
    },
    {
      "from": null,
      "id": 309,
      "name": "div",
      "parent": 311,
      "props": {
        "children": {
          "type": "code",
          "value": "props.experienceInfo"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-309"
        }
      },
      "seq": 309,
      "void": false
    },
    {
      "from": null,
      "id": 310,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-310"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", flexDirection: \"column\", alignItems: \"center\", marginRight: \"24px\", marginLeft: \"12px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 311,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-311"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 312,
      "name": "div",
      "parent": 311,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-div-312"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 313,
      "name": "FormGroup",
      "parent": 195,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeInformationUX-FormGroup-313"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0\", alignSelf: \"flex-end\"}"
        },
        "widths": {
          "type": "code",
          "value": "7"
        }
      },
      "seq": 197,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardEmployeeInformationUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
